<ion-header>
  <app-page-header [backName]="this.lessonUuid !== null ? 'Lesson' :  'Lesson Plans'" popoverCssClass='lesson-plans' [courseUuid]='this.courseUuid' [lessonUuid]='this.lessonUuid'></app-page-header>

  <div [ngClass]="['top', bowlingSongCssService.responsiveClass()]">
    <div class='contents'>
      <button class='week' (click)='presentPagePopover($event)'>{{selectedPage}}<i class='mt-arrow-down'></i></button>
      <h1>Bowling Sheet - {{resources.findCollection(course.collectionUuid)?.name}}</h1>
    </div>

    <div class='bar'>
      <div class='buttons'>
        <button class='name-column'>Song Name</button>
        <section (scroll)='onScroll($event)' [scrollLeft]='scrollLeft'>
          <ng-container *ngFor='let index of weekItems'>
            <button (click)='gotoWeek(index-1)' class="week-column">Week {{index}}</button>
          </ng-container>
        </section>
        <button class='info-column'></button>
      </div>
    </div>
  </div>  
</ion-header>

<ion-content id='content' appScrollBounce>
  <div class='middle'>
    <table [ngClass]="['songs', bowlingSongCssService.responsiveClass()]" (scroll)='onScroll($event)' [scrollLeft]='scrollLeft'>
      <tbody>
      <ng-container class='song' *ngFor='let song of songs; trackBy: trackbySongUuid'>
        <tr><th></th></tr>
        <tr>
          <td rowspan='2' class='name'><h2>{{song.name}}</h2></td>
          <td class='activity-number' colspan='12'>Lesson Plan Slot</td>
          <td class='info' rowspan='2'>
            <!-- <div>
              <button (click)='showSongInfo(song)'><i class='mt-info'></i></button>
            </div> -->
          </td>
        </tr>
        <tr app-bowling-song [course]='course' [lessonByPage]="lessonByPage" [song]='song'></tr>
      </ng-container>
      </tbody>
    </table>
  </div>
</ion-content>

<ion-menu 
 menuId="song-details-bowling-menu" 
 class='song-detail-slideout' 
 type='overlay' 
 side='end' 
 (ionDidClose)='audioProvider.stop()' 
 contentId='content'>
  <div class='menu'>
    <div class='header'>
      <div class='title-area'>
        <button class='done' (click)='doneSongInfo()'>Done</button>
      </div>
    </div>
      
    <app-song-detail [course]='course' [song]='songInfoSong'></app-song-detail>
  </div>
</ion-menu>
      
